function loadGallery(attachments) {

    function getSlide(num, type) {
        var currentSlide = attachments[num];
        var div = document.createElement('div');
        var item;

        if (currentSlide.type === image) {
            item = document.createElement('img');
            item.setAttribute('src', currentSlide.link);
            item.setAttribute('alt', currentSlide.title);
        } else if (currentSlide.type === video) {

            div.classList.add('video');

            if (currentSlide.isRemote) {
                item = document.createElement('iframe');
                item.setAttribute('src', currentSlide.link);
                item.setAttribute('allow', "autoplay; encrypted-media");
                item.setAttribute('allowfullscreen', '');
            } else {
                item = document.createElement('video');
                item.setAttribute('src', currentSlide.link);
                item.setAttribute('controls', '');
            }
        }

        div.appendChild(item);
        div.classList.add(types[type]);

        return div;
    }

    function setCaption(num) {
        if (attachments[num].title !== null) {
            caption.innerHTML = attachments[num].title;
        } else {
            caption.innerHTML = "";
        }
    }

    if (attachments.length > 0) {
        var image = 1;
        var video = 3;

        var types = {
            previous: 'previous',
            current: 'current',
            next: 'next'
        };

        var current = 0;

        if (attachments.length > 1) {
            var previous = attachments.length - 1;
            var next = 1;
        }

        var gallery = document.querySelector('.gallery');
        var caption = gallery.nextElementSibling;

        // Up button
        var up = document.createElement('button');
        up.classList.add('up');
        up.addEventListener('click', function (e) {
            e.preventDefault();

            var previousDiv = gallery.querySelector('div.previous');
            var currentDiv = gallery.querySelector('div.current');
            var nextDiv = gallery.querySelector('div.next');

            gallery.removeChild(nextDiv);

            currentDiv.classList.toggle('current');
            currentDiv.classList.toggle('next');

            previousDiv.classList.toggle('previous');
            previousDiv.classList.toggle('current');

            next = current;
            current = previous;
            previous -= 1;
            if (previous < 0) {
                previous = attachments.length - 1;
            }

            gallery.appendChild(getSlide(previous, types.previous));
            setCaption(current);
        });

        // Down button
        var down = document.createElement('button');
        down.classList.add('down');
        down.addEventListener('click', function (e) {
            e.preventDefault();

            var previousDiv = gallery.querySelector('div.previous');
            var currentDiv = gallery.querySelector('div.current');
            var nextDiv = gallery.querySelector('div.next');

            gallery.removeChild(previousDiv);

            currentDiv.classList.toggle('current');
            currentDiv.classList.toggle('previous');

            nextDiv.classList.toggle('next');
            nextDiv.classList.toggle('current');

            previous = current;
            current = next;
            next += 1;
            if (next > attachments.length - 1) {
                next = 0;
            }

            gallery.appendChild(getSlide(next, types.next));
            setCaption(current);
        });

        gallery.appendChild(getSlide(current, types.current));
        setCaption(current);

        if (attachments.length > 1) {
            gallery.appendChild(getSlide(previous, types.previous));
            gallery.appendChild(getSlide(next, types.next));
            gallery.appendChild(up);
            gallery.appendChild(down);
        }

    }
}